import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TablePagination from '@material-ui/core/TablePagination'
import TableRow from '@material-ui/core/TableRow'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import FilterListIcon from '@material-ui/icons/FilterList'
import { lighten } from '@material-ui/core/styles/colorManipulator'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'

class TableTitle extends React.Component {
  render() {
    const {
      classes,
      onIconClick,
      iconLabel,
      header,
      addIcon = true,
      withBottomBorder
    } = this.props

    return (
      <Toolbar
        className={classNames(classes.titleRoot)}
        style={{
          borderBottom: withBottomBorder
            ? '1px solid rgba(224, 224, 224, 1)'
            : 'transparent'
        }}
      >
        <div className={classes.title}>
          <Typography variant="title" id="tableTitle">
            {header}
          </Typography>
        </div>
        <div className={classes.spacer} />
        {addIcon ? (
          <div className={classes.actions}>
            <Tooltip title={iconLabel}>
              <IconButton aria-label={iconLabel} onClick={() => onIconClick()}>
                <FontAwesomeIcon icon={faPlus} color={'#289e64'} />
              </IconButton>
            </Tooltip>
          </div>
        ) : null}
      </Toolbar>
    )
  }
}

TableTitle.propTypes = {
  classes: PropTypes.object.isRequired
}

export { TableTitle }



// WEBPACK FOOTER //
// ./src/components/common/TableTitle.js